export default function GreyBankIcon() {
  return (
    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.6797 12.3634H3.67969C2.71969 12.3634 1.92969 11.5734 1.92969 10.6134V7.29341C1.92969 6.61341 2.39966 5.92341 3.02966 5.67341L12.0297 2.07344C12.4097 1.92344 12.9497 1.92344 13.3297 2.07344L22.3297 5.67341C22.9597 5.92341 23.4297 6.62341 23.4297 7.29341V10.6134C23.4297 11.5734 22.6397 12.3634 21.6797 12.3634ZM12.6797 3.45344C12.6397 3.45344 12.5997 3.45339 12.5797 3.46339L3.58966 7.06343C3.52966 7.09343 3.42969 7.22341 3.42969 7.29341V10.6134C3.42969 10.7534 3.53969 10.8634 3.67969 10.8634H21.6797C21.8197 10.8634 21.9297 10.7534 21.9297 10.6134V7.29341C21.9297 7.22341 21.8397 7.09343 21.7697 7.06343L12.7697 3.46339C12.7497 3.45339 12.7197 3.45344 12.6797 3.45344Z"
        fill="#91A2BB"
      />
      <path
        d="M22.6797 23.3672H2.67969C2.26969 23.3672 1.92969 23.0272 1.92969 22.6172V19.6172C1.92969 18.6572 2.71969 17.8672 3.67969 17.8672H21.6797C22.6397 17.8672 23.4297 18.6572 23.4297 19.6172V22.6172C23.4297 23.0272 23.0897 23.3672 22.6797 23.3672ZM3.42969 21.8672H21.9297V19.6172C21.9297 19.4772 21.8197 19.3672 21.6797 19.3672H3.67969C3.53969 19.3672 3.42969 19.4772 3.42969 19.6172V21.8672Z"
        fill="#91A2BB"
      />
      <path
        d="M4.67969 19.3672C4.26969 19.3672 3.92969 19.0272 3.92969 18.6172V11.6172C3.92969 11.2072 4.26969 10.8672 4.67969 10.8672C5.08969 10.8672 5.42969 11.2072 5.42969 11.6172V18.6172C5.42969 19.0272 5.08969 19.3672 4.67969 19.3672Z"
        fill="#91A2BB"
      />
      <path
        d="M8.67969 19.3672C8.26969 19.3672 7.92969 19.0272 7.92969 18.6172V11.6172C7.92969 11.2072 8.26969 10.8672 8.67969 10.8672C9.08969 10.8672 9.42969 11.2072 9.42969 11.6172V18.6172C9.42969 19.0272 9.08969 19.3672 8.67969 19.3672Z"
        fill="#91A2BB"
      />
      <path
        d="M12.6797 19.3672C12.2697 19.3672 11.9297 19.0272 11.9297 18.6172V11.6172C11.9297 11.2072 12.2697 10.8672 12.6797 10.8672C13.0897 10.8672 13.4297 11.2072 13.4297 11.6172V18.6172C13.4297 19.0272 13.0897 19.3672 12.6797 19.3672Z"
        fill="#91A2BB"
      />
      <path
        d="M16.6797 19.3672C16.2697 19.3672 15.9297 19.0272 15.9297 18.6172V11.6172C15.9297 11.2072 16.2697 10.8672 16.6797 10.8672C17.0897 10.8672 17.4297 11.2072 17.4297 11.6172V18.6172C17.4297 19.0272 17.0897 19.3672 16.6797 19.3672Z"
        fill="#91A2BB"
      />
      <path
        d="M20.6797 19.3672C20.2697 19.3672 19.9297 19.0272 19.9297 18.6172V11.6172C19.9297 11.2072 20.2697 10.8672 20.6797 10.8672C21.0897 10.8672 21.4297 11.2072 21.4297 11.6172V18.6172C21.4297 19.0272 21.0897 19.3672 20.6797 19.3672Z"
        fill="#91A2BB"
      />
      <path
        d="M23.6797 23.3672H1.67969C1.26969 23.3672 0.929688 23.0272 0.929688 22.6172C0.929688 22.2072 1.26969 21.8672 1.67969 21.8672H23.6797C24.0897 21.8672 24.4297 22.2072 24.4297 22.6172C24.4297 23.0272 24.0897 23.3672 23.6797 23.3672Z"
        fill="#91A2BB"
      />
      <path
        d="M12.6797 9.86719C11.4397 9.86719 10.4297 8.85719 10.4297 7.61719C10.4297 6.37719 11.4397 5.36719 12.6797 5.36719C13.9197 5.36719 14.9297 6.37719 14.9297 7.61719C14.9297 8.85719 13.9197 9.86719 12.6797 9.86719ZM12.6797 6.86719C12.2697 6.86719 11.9297 7.20719 11.9297 7.61719C11.9297 8.02719 12.2697 8.36719 12.6797 8.36719C13.0897 8.36719 13.4297 8.02719 13.4297 7.61719C13.4297 7.20719 13.0897 6.86719 12.6797 6.86719Z"
        fill="#91A2BB"
      />
    </svg>
  );
}
